export default __webpack_public_path__ + "static/study-cafe3-2fb048ae8d9c34cc2f256adbc147e3c3.jpg";